<div class="wrapper" [class.disabled]="disabled">
  <button
    class="block fill relative ps-medium"
    [attr.aria-controls]="expandContainerId"
    [disabled]="disabled"
    (click)="toggleOpen()"
  >
    <div class="header flex flex--top">
      <div class="header-icon flex--nogrow flex flex--top ps-small-r" [class.dn-mobile]="hideIconInMobile">
        <fcom-icon [category]="iconCategory" [name]="iconName" class="icon-large" [ngClass]="iconClasses" />
      </div>
      <div class="">
        <div
          class="header-content flex align-left"
          [class.flex--align-end]="!isNewBrand()"
          [class.flex--middle]="isNewBrand()"
        >
          <h4
            data-testid="expander-card-title"
            class="header-title nordic-blue-900-text text-icon-primary font-heading-4 ps-small-r font-title-medium"
            [class.capitalize]="capitalizeTitle"
            [attr.aria-describedby]="'subtitle-' + expandContainerId"
          >
            {{ title }}
          </h4>
          <div
            *ngIf="subTitle || subTitleIcon"
            class="header-subtitle-wrapper flex--nogrow flex flex--center"
            [ngClass]="{ 'dn-mobile': !showSubTitleOnMobile }"
          >
            <fcom-icon
              *ngIf="subTitleIcon"
              [name]="subTitleIcon"
              [category]="iconCategory"
              class="ps-xxsmall-r"
              [class.icon-small]="!isNewBrand()"
              [class.icon-medium]="isNewBrand()"
              [ngClass]="iconClasses"
            />
            <div
              *ngIf="subTitle"
              class="header-subtitle font-body-1 nordic-blue-900-text text-icon-primary font-body-medium"
              [attr.id]="'subtitle-' + expandContainerId"
              data-testid="expander-card-subtitle"
            >
              {{ subTitle }}
            </div>
          </div>
        </div>

        <div
          *ngIf="(!expandOpen || showDescriptionAlways) && descriptionContent"
          [ngClass]="descriptionClasses"
          class="nordic-blue-900-text text-icon-primary font-body-1 align-left font-body-medium"
          data-testid="booking-expander-description"
          data-hj-suppress
          data-dd-privacy="hidden"
        >
          <ng-container *ngTemplateOutlet="descriptionContent" />
        </div>
      </div>
    </div>

    <fcom-icon
      class="ms-medium chevron-down rotate absolute nordic-blue-900-text text-icon-primary"
      [name]="SvgLibraryIcon.CHEVRON_DOWN"
      [class.rotate-active]="expandOpen"
    />
  </button>

  <fcom-expand
    [ariaId]="expandContainerId"
    class="block"
    [open]="expandOpen"
    [ariaLabelledBy]="'pax-expander-' + expandContainerId"
  >
    <ng-content select="expandedContent" />
  </fcom-expand>

  <ng-content select="content" />
</div>
